import { createReducer } from 'redux-act';
import { TimelineStore } from './interfaces';

const initialState = {};

const rootReducer = createReducer<TimelineStore>({}, initialState);

export default rootReducer;
